<script>
  import VideoPreview from './previews/VideoPreview.svelte';

  export let src = '';
  export let name = 'video';
  export let mode = 'message';
  export let mime = '';
</script>

<VideoPreview {src} {name} {mode} {mime} />
